module.exports = __webpack_public_path__ + "img/004.256df05e.png";